import { render, staticRenderFns } from "./ZDrugCollection.vue?vue&type=template&id=353aaf55&scoped=true"
import script from "./ZDrugCollection.vue?vue&type=script&lang=js"
export * from "./ZDrugCollection.vue?vue&type=script&lang=js"
import style0 from "./ZDrugCollection.vue?vue&type=style&index=0&id=353aaf55&prod&scoped=true&lang=css"
import style1 from "./ZDrugCollection.vue?vue&type=style&index=1&id=353aaf55&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353aaf55",
  null
  
)

export default component.exports